'use client';

import { FC } from 'react';
import { Collapse } from '@mui/material';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useTranslations } from 'next-intl';
import {
  Card,
  CardCollapseBody,
  CardSubtitle,
  CardTitle,
  CardTitleHeader,
  CollapseToggle,
} from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/styled';
import { WlasChevronIcon } from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/components/WlasParamsCard/components/WlasSection/WlasChevronIcon';
import { FaqBody, FaqItem, FaqQuestion, FaqAnswer } from './styled';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5'] as const;

export const WlasFaqCard: FC = () => {
  const t = useTranslations('wlasWidget');
  const [open, setOpen] = useLocalStorage('wlas-card-faq-open', true);

  return (
    <Card>
      <CardTitleHeader onClick={() => setOpen((v: boolean) => !v)}>
        <div>
          <CardTitle>{t('faq.title')}</CardTitle>
          <CardSubtitle>
            {FAQ_KEYS.length} {t('faq.itemCount')}
          </CardSubtitle>
        </div>

        <CollapseToggle
          type="button"
          aria-expanded={open}
          aria-controls="wlas-faq-body"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((v: boolean) => !v);
          }}
        >
          <WlasChevronIcon open={open} />
        </CollapseToggle>
      </CardTitleHeader>

      <Collapse in={open} aria-hidden={!open}>
        <CardCollapseBody>
          <FaqBody id="wlas-faq-body">
            {FAQ_KEYS.map((key) => (
              <FaqItem key={key}>
                <FaqQuestion>{t(`faq.${key}.q`)}</FaqQuestion>
                <FaqAnswer>{t(`faq.${key}.a`)}</FaqAnswer>
              </FaqItem>
            ))}
          </FaqBody>
        </CardCollapseBody>
      </Collapse>
    </Card>
  );
};
